module.exports = __webpack_public_path__ + "static/media/icon_warn.a83a019f.svg";